import { CdkAccordionModule } from "@angular/cdk/accordion";
import { CommonModule } from "@angular/common";
import { Component, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { select, Store } from "@ngrx/store";
import { filter, Observable, take } from "rxjs";
import { AppState } from "../../../app.state";
import { IDespacho, Informativo, VoBo } from "../../../interfaces/despacho";
import { OrderByPipe } from "../../../pipes/order-by.pipe";
import {
  consultarDespachos,
  esNuevoDespacho,
  resetDespacho,
  seleccionarDespacho,
  updateStatusDespacho,
} from "../../../states/despacho/actions";
import {
  selectDespachoActual,
  selectDespachosTodos,
  selectEsNuevoDespacho,
  selectStatusDespacho,
} from "../../../states/despacho/selector";
import { ImprimirDialogComponent } from "../dialogs/dialog-imprimir/imprimir-dialog.component";
import { InformativoVoboComponent } from "../informativo-vobo/informativo-vobo.component";
import { NuevoDespachoComponent } from "../nuevo-despacho/nuevo-despacho.component";
import { selectStatusAcuerdo } from "../../../states/temas/selectors";
import { DespachoService } from "../../../services/despacho/despacho.service";

@Component({
  selector: "app-table-despacho",
  standalone: true,
  templateUrl: "./table-despacho.component.html",
  styleUrl: "./table-despacho.component.css",
  providers: [provideNativeDateAdapter()],
  imports: [
    MatExpansionModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    CommonModule,
    MatCardModule,
    InformativoVoboComponent,
    MatRadioModule,
    FormsModule,
    //OrderByPipe,
    NuevoDespachoComponent,
    CdkAccordionModule,
  ],
})
export class TableDespachoComponent {
  public despachos$!: Observable<IDespacho[]>;
  public despachoActual$!: Observable<IDespacho>;
  public nuevoDespacho$!: Observable<boolean>;
  public statusDespacho$!: Observable<string>;
  public openPanelItem!: IDespacho | null;
  public tipoDespacho = 0;
  public nuevoDespacho = false;
  public allForms!: FormGroup;
  public tiposDespacho = [
    {
      id: 0,
      descripcion: "Ver todos",
    },

    {
      id: 2,
      descripcion: "VoBo",
    },
    {
      id: 1,
      descripcion: "Informativo",
    },
  ];

  constructor(
    public store: Store<AppState>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public despachoService: DespachoService,
  ) {
    this.allForms = this.fb.group({});
  }

  async ngOnInit() {
    this.store.dispatch(resetDespacho());
    this.despachoActual$ = this.store.select(selectDespachoActual);
    this.nuevoDespacho$ = this.store.pipe(select(selectEsNuevoDespacho));
    this.nuevoDespacho$.subscribe((nuevoDespacho) => {
      this.nuevoDespacho = nuevoDespacho;
    });
    this.store.dispatch(consultarDespachos());
    this.loadDespachos();

    ///volver a cargarr despachos al elimar o cambiar de estatus algun tema
    this.statusDespacho$ = this.store.select(selectStatusDespacho);
    this.statusDespacho$.subscribe((status) => {
      console.log("status", status);
      const acciones = [
        "accionQuitar",
        "cancelarEntregable",
        "terminarEntregable",
        "terminarSeguimiento",
        "terminar",
      ];
      if (status && acciones.includes(status)) {
        console.log("accionQuitar exito", status);
        this.store.dispatch(updateStatusDespacho({ status: "" }));
        this.loadDespachos();
      }
    });
  }

  loadDespachos() {
    this.despachos$ = this.store.select(selectDespachosTodos);
    this.despachos$
      .pipe(filter((despachos) => despachos && despachos.length > 0))
      .subscribe((despachos) => {
        this.initializeForms(despachos);
      });
  }
  initializeForms(despachos: IDespacho[]) {
    this.allForms = this.fb.group({});
    despachos.forEach((despacho) => {
      const companyFormGroup = this.fb.group({
        informativo: this.fb.array(this.createFormGroup(despacho.Informativo)),
        vobo: this.fb.array(this.createFormGroup(despacho.VoBo)),
      });
      this.allForms.addControl(despacho.id_empresa, companyFormGroup);
    });
  }

  showDespachoByTipo(despacho: IDespacho): boolean {
    switch (this.tipoDespacho) {
      case 0:
        return true;
      case 1:
        return despacho.Informativo && despacho.Informativo.length > 0;
      case 2:
        return despacho.VoBo && despacho.VoBo.length > 0;
      default:
        break;
    }
    return false;
  }
  getFilteredDespachos(despachos: any[]): any[] {
    switch (this.tipoDespacho) {
      case 0:
        return despachos;
      case 1:
        return despachos.filter(
          (despacho) => despacho.Informativo && despacho.Informativo.length > 0
        );
      case 2:
        return despachos.filter(
          (despacho) => despacho.VoBo && despacho.VoBo.length > 0
        );
      default:
        return despachos;
    }
  }

  imprimir() {
    this.dialog.open(ImprimirDialogComponent, {
      width: "450px",
      data: this.allForms,
    });
  }

  selectDespacho(despacho: IDespacho) {
    this.openPanelItem = despacho;
    this.store.dispatch(
      seleccionarDespacho({
        despacho: { ...despacho },
      })
    );
  }

  togglePanel(item: IDespacho, open: boolean) {
    let despacho = { ...item };
    despacho.expanded = !open;
    this.store.dispatch(
      seleccionarDespacho({
        despacho,
      })
    );
  }

  addNuevoDespacho() {
    this.store.dispatch(esNuevoDespacho());
  }

  createFormGroup(temas: VoBo[] | Informativo[]): FormGroup[] {
    if (temas.length > 0) {
      return temas.map((tema) =>
        this.fb.group({
          id_tema: [tema.id_tema],
          id_edo_tema: [tema.id_edo_tema],
          nombreTema: [tema.nombreTema, [Validators.required]],
          descripcionTema: [tema.descripcionTema],
          id_tipo_despacho: [tema.id_tipo_despacho],
          indice: [tema.indice],
          descripcion: [tema.descripcion],
          id_empresa: [tema.id_empresa],
          banEsImpreso: [tema.banEsImpreso],
          ts_alta_audit: [tema.ts_alta_audit],
          nombre_empresa: [tema.nombre_empresa],
          entradas: [tema.entradas],
          entradaSelected: [""],
          marcarParaImpresion: [false],
          accion: [null],
        })
      );
    }
    return [];
  }

  getEmpresaKeys(): string[] {
    return Object.keys(this.allForms.controls);
  }

  ngOnDestroy() {
    this.despachoService.setImpresion([]);
  }
}
